/**
 * 竞价预告列表页路径
 */
export const APPLY_ANNOUNCEMENT_LIST_PAGE_PATH = '/announcement/apply/list'

/**
 * 竞价预告详情页路径
 */
export const APPLY_ANNOUNCEMENT_DETAIL_PAGE_PATH = '/announcement/apply/detail'
